import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Flag } from "@phosphor-icons/react";
import { BulaLogo } from "@/components/BulaLogo";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { toast.success("Welcome back!"); navigate("/dashboard"); }
    else toast.error(r.error);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-[#F8F7F3]">
      <div className="relative hidden md:block">
        <img src="https://images.unsplash.com/photo-1636315662384-8406112deaf1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F2537]/90 to-[#0F2537]/40" />
        <div className="relative z-10 h-full p-12 flex flex-col justify-between text-white">
          <Link to="/" className="flex items-center gap-2 w-fit" data-testid="login-logo">
            <BulaLogo size={36} />
            <span className="font-heading font-black text-lg">Bula Golf</span>
          </Link>
          <div>
            <h2 className="font-heading font-black text-4xl tracking-tighter">Welcome back, golfer.</h2>
            <p className="mt-3 text-white/80 max-w-sm">Sign in to record a round, check your handicap and see where you sit on the leaderboard.</p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-6 md:p-12">
        <form onSubmit={submit} className="w-full max-w-md card-default p-8 rise" data-testid="login-form">
          <span className="label-eyebrow">Sign in</span>
          <h1 className="font-heading font-black text-3xl mt-1">Tee off again</h1>
          <p className="text-[#0F2537]/70 text-sm mt-1">Enter your details below.</p>

          <label className="block mt-6 text-sm font-semibold">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            className="mt-1 w-full px-4 py-3 rounded-xl border border-[#E2E0D8] bg-white focus:outline-none focus:border-[#0F2537]" />

          <label className="block mt-4 text-sm font-semibold">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            className="mt-1 w-full px-4 py-3 rounded-xl border border-[#E2E0D8] bg-white focus:outline-none focus:border-[#0F2537]" />

          <div className="mt-2 text-right">
            <Link to="/forgot-password" data-testid="login-forgot-password-link" className="text-xs font-semibold text-[#0F2537]/70 hover:text-[#E05D3A]">
              Forgot password?
            </Link>
          </div>

          <button type="submit" disabled={loading} data-testid="login-submit-btn"
            className="mt-6 w-full py-3 rounded-xl bg-[#0F2537] text-white font-bold hover:bg-[#0F2537]/90 transition disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>

          <p className="mt-5 text-sm text-[#0F2537]/70 text-center">
            No account?{" "}
            <Link to="/register" data-testid="login-to-register-link" className="text-[#E05D3A] font-semibold">Create one</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
